
export class CodeSetsParameters {
  ProviderId: string;
  ServiceCodesIds: number[];
  DiagnosesIds: number[];
}
